import { Component, Input } from '@angular/core';
import { IconSize } from '../../core-data-model/IconSize';

@Component({
    selector: 'ba-report-icon',
    template: `
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            attr.width="{{ iconSize }}"
            attr.height="{{ iconSize }}"
            version="1.1"
        >
            <defs>
                <path
                    d="M0,53 C0,82.271 23.729,106 53,106 L53,106 C82.271,106 106,82.271 106,53 L106,53 C106,23.729 82.271,0 53,0 L53,0 C23.729,0 0,23.729 0,53 L0,53 Z"
                    id="ba-path-1"
                />
                <polygon
                    id="ba-path-3"
                    points="0 0.0003125 44 0.0003125 44 50 0 50"
                    style="&#10;"
                />
            </defs>
            <g
                id="ba-Person-Page-"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
            >
                <g
                    id="ba-B-Person-page--more-people-added-"
                    transform="translate(-655.000000, -1617.000000)"
                >
                    <g
                        id="ba-Group-4"
                        transform="translate(657.000000, 1619.000000)"
                    >
                        <g id="ba-Group-23">
                            <path
                                d="M53,106 C82.271,106 106,82.271 106,53 C106,23.729 82.271,0 53,0 C23.729,0 0,23.729 0,53 C0,82.271 23.729,106 53,106 Z"
                                id="ba-Stroke-1"
                                stroke="#0092C8"
                                stroke-width="2.4"
                            />
                            <g id="ba-Group-6">
                                <mask
                                    class="svgWrapperShape"
                                    id="ba-mask-2"
                                    fill="white"
                                >
                                    <use xlink:href="#ba-path-1" />
                                </mask>
                                <g id="ba-Clip-4" />
                                <polygon
                                    id="ba-Fill-3"
                                    fill="#F3FBFE"
                                    mask="url(#ba-mask-2)"
                                    points="-5 111 111 111 111 -5 -5 -5"
                                />
                                <path
                                    class="svgWrapperShape"
                                    d="M53,106 C82.271,106 106,82.271 106,53 C106,23.729 82.271,0 53,0 C23.729,0 0,23.729 0,53 C0,82.271 23.729,106 53,106 Z"
                                    id="ba-Stroke-5"
                                    stroke="#0092C8"
                                    stroke-width="6.4"
                                    mask="url(#ba-mask-2)"
                                />
                            </g>
                        </g>
                        <g
                            id="ba-Group-11"
                            transform="translate(32.000000, 26.000000)"
                        >
                            <polygon
                                id="ba-Fill-1"
                                fill="#3D1C70"
                                points="9 35 30 35 30 31 9 31"
                            />
                            <polygon
                                id="ba-Fill-2"
                                fill="#3D1C70"
                                points="9 41 30 41 30 37 9 37"
                            />
                            <g id="ba-Group-10">
                                <path
                                    d="M11.7857143,17.58 C11.7857143,14.9925 13.8977143,12.8925 16.5,12.8925 C19.1022857,12.8925 21.2142857,14.9925 21.2142857,17.58 C21.2142857,20.1675 19.1022857,22.2675 16.5,22.2675 C13.8977143,22.2675 11.7857143,20.1675 11.7857143,17.58"
                                    id="ba-Fill-3"
                                    fill="#3D1C70"
                                />
                                <path
                                    d="M19.6428571,22.2675 L13.3571429,22.2675 C10.7642857,22.2675 8.64285714,23.67375 8.64285714,25.3925 L8.64285714,28.5175 L24.3571429,28.5175 L24.3571429,25.3925 C24.3571429,23.67375 22.2357143,22.2675 19.6428571,22.2675"
                                    id="ba-Fill-5"
                                    fill="#3D1C70"
                                />
                                <g id="ba-Group-9">
                                    <mask id="ba-mask-4" fill="white">
                                        <use xlink:href="#ba-path-3" />
                                    </mask>
                                    <g id="ba-Clip-8" />
                                    <path
                                        d="M40.8571429,46.0940625 C40.8571429,46.5190625 40.4988571,46.8753125 40.0714286,46.8753125 L3.92857143,46.8753125 C3.50428571,46.8753125 3.14285714,46.5190625 3.14285714,46.0940625 L3.14285714,3.9065625 C3.14285714,3.4846875 3.50428571,3.1253125 3.92857143,3.1253125 L28.2857143,3.1253125 L28.2857143,14.0628125 C28.2857143,14.9253125 28.9897143,15.6253125 29.8571429,15.6253125 L40.8571429,15.6253125 L40.8571429,46.0940625 Z M35.4231429,8.5284375 C36.9317143,10.0284375 38.1134286,11.3784375 38.9871429,12.5003125 L31.4254286,12.5003125 L31.4254286,4.9846875 C32.5537143,5.8534375 33.9145714,7.0284375 35.42,8.5284375 L35.4231429,8.5284375 Z M41.9288571,11.1846875 C40.8382857,9.7065625 39.3171429,7.9753125 37.6482857,6.3159375 C35.9794286,4.6565625 34.2382857,3.1440625 32.7517143,2.0596875 C30.2185714,0.2128125 28.9897143,0.0003125 28.2857143,0.0003125 L3.92857143,0.0003125 C1.76314286,0.0003125 0,1.7534375 0,3.9065625 L0,46.0940625 C0,48.2471875 1.76314286,50.0003125 3.92857143,50.0003125 L40.0714286,50.0003125 C42.2368571,50.0003125 44,48.2471875 44,46.0940625 L44,15.6253125 C44,14.9253125 43.7862857,13.7034375 41.9288571,11.1846875 L41.9288571,11.1846875 Z"
                                        id="ba-Fill-7"
                                        fill="#3D1C70"
                                        mask="url(#ba-mask-4)"
                                    />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    `,
    standalone: false
})
export class BAReportIconComponent {
    @Input()
    iconSize: IconSize;
}
